import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { locationSearchSchema } from "../../lib/searchParams";
import YearView from "../../pages/YearView";

export const Route = createFileRoute("/_app/year")({
	validateSearch: zodValidator(locationSearchSchema),
	component: YearView,
});
